import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Footer from '../../components/Footer';
import { minNavHeight } from '../../styles/styleVariables';

const ContentArea = styled.div`
  min-height: calc(100vh - ${minNavHeight});
  margin-bottom: 0rem;
`;

const Layout = ({ children }) => (
  <div>
    <ContentArea>
      { children }
    </ContentArea>
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.element.isRequired,
};


export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js